import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiPost, ApiError } from '../lib/api';
import { setSession, type AuthedUser } from '../lib/auth';

export function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const r = await apiPost<{ token: string; user: AuthedUser }>(
        '/api/auth/login',
        { email, password }
      );
      setSession(r.token, r.user);
      navigate('/', { replace: true });
    } catch (e) {
      if (e instanceof ApiError && e.status === 429) setErr('Too many attempts. Wait a minute.');
      else if (e instanceof ApiError && e.status === 401) setErr('Wrong email or password.');
      else setErr((e as Error).message || 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-bg">
      <form onSubmit={submit} className="w-full max-w-sm card space-y-4">
        <div>
          <h1 className="text-2xl font-bold text-accent">NextGear Bookings</h1>
          <p className="text-sm text-muted mt-1">Sign in to your shop.</p>
        </div>

        <div>
          <label className="label">Email</label>
          <input
            className="input"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div>
          <label className="label">Password</label>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {err && <p className="text-rose-400 text-sm">{err}</p>}

        <button type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-50">
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
